import React, { useState } from "react"
import styled from "styled-components/macro"
import Col from "react-bootstrap/esm/Col"
import { Form } from "react-bootstrap"
import { LogoFooter, ArrowRight } from "../../assets/icons"
import { size } from "../../utils/breakpoints"
import ScrollToTop from "../buttons/ScrollToTop"
import {
  FaFacebookF,
  FaLinkedinIn,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6"
import { AiFillInstagram } from "react-icons/ai"

const FooterContainer = styled.div`
  background-color: var(--darkBlue2) !important;
  /* max-width: 80rem; */
  height: auto;
  width: 100%;
  padding: 0px 10px;
  .logo {
    img {
      width: 2.813rem;
      height: 2.5rem;
    }
  }
`
const ContentContainer = styled.div`
  height: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 45px 0px 25px 0px;
  font-size: 0.875rem;
`

const SectionsContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .icons-mobile {
    margin-bottom: 30px;
    display: flex;
    img {
      height: 2.063rem;
      width: auto;
    }
    justify-content: end;
    gap: 1rem;
    align-items: center;
  }
  .contact-privacy-box {
    margin-bottom: 30px;
    opacity: 0.8;
  }
  .bulletin-container {
    justify-content: center;
    margin-bottom: 30px;
    width: 100%;
  }
  p {
    color: #fff;
  }
  .contact-privacy-box {
    a {
      color: #fff;
      text-decoration: none;
    }
  }
  .logo-container {
    width: 100%;
  }
  .logo-container {
    margin-bottom: 1.875rem;
  }
  .global {
    font-weight: 300;
  }
  .bulletin-signup {
    font-weight: 700;
  }
  .button-subscribe {
    font-family: "Helvetica Neue LT Std", sans-serif;
  }

  @media ${size.smm} {
    display: flex;
    gap: 5px;

    .global-links {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 20px;
    }

    .privacy {
      display: flex;
      flex-wrap: wrap;
      .privacy-item {
        width: 30%; 
      }
    }
    
  }

  @media ${size.md} {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .privacy {
      display: flex;
      flex-wrap: wrap;
      .privacy-item {
        width: 30%; 
      }
    }
    .item {
      width: 50%;
    }
  }

  @media ${size.lg} {
    align-items: unset;
    flex-direction: row;
    justify-content: space-between;

    .privacy {
      display: flex;
      flex-wrap: wrap;
      .privacy-item {
        width: 100%; 
      }
    }
    .icons-mobile {
      display: none;
    }
    .global {
      display: flex;
      flex-direction: column;
    }
    .privacy-item {
      width: 100%; 
    }
    .logo-container {
      width: unset !important;
    }
    .logo-container,
    .global,
    .contact-privacy-box {
      /* margin-bottom: 0 !important; */
      flex-grow: 1;
      margin: 0 30px 10px 0;
    }
    .bulletin-container {
      flex-grow: 1;
      width: unset;
    }
    .contact-privacy-box {
      display: flex;
    }
    .global {
      grid-template-columns: unset !important;
    }
  }
`
const ColContainer = styled.div`
  .item {
    margin-bottom: 0.1rem;
    font-family: "Helvetica Neue LT Std", sans-serif;
    font-weight: 500;
    font-size: 14px;
    width: 100%;
  }
  .privacy-item {
    font-family: "Helvetica Neue LT Std", sans-serif;
    font-weight: 300;
    opacity: 0.8;
  }
  display: flex;
  .logo {
    svg {
      height: 66.898px;
      width: 75.667px;
    }
  }
  .bulletin-box {
    width: 100%;
  }
  /* MEDIA */
  @media ${size.md} {
    .bulletin-box {
      display: flex;
      flex-direction: column;
      .form-col {
        display: flex;
        justify-content: end;
      }
    }
  }
`
const ColBox = styled.div`
  .global-item {
    /* padding-bottom: 0.3rem; */
    font-family: "Helvetica Neue LT Std", sans-serif;
  }
  .icons-container {
    visibility: hidden;
    height: 0;
    width: 0;
    margin-bottom: 0 !important;
  }
  /* 'initial', sometimes its the value 'auto' or 'none' */
  .form-control {
    display: auto;
    width: 100%;
    /* width: 100%; this was the solution to have a bigger email
     space but instead we will need to increase size of right container*/
    padding: inherit;
    font-size: auto;
    font-weight: auto;
    line-height: inherit;
    color: auto;
    background-color: inherit;
    background-clip: inherit;
    border: auto;
    appearance: inherit;
    border-radius: inherit;
    transition: border-color none;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition: background-color 600000s 0s, color 600000s 0s;
  }
  .form-control:focus {
    color: #fff;
    background-color: transparent;
    border-color: #fff !important;
    outline: inherit;
    box-shadow: none;
  }

  .bulletin-signup {
    display: flex;
    gap: 0.7rem;
    /* flex-direction: column; */
    align-items: end;
    .form-label {
      margin: 0;
      color: #fff;
      font-weight: 700;
      font-size: 14px;
      line-height: 1;
    }
    button {
      font-size: 12px;
      display: flex;
      margin-left: 0.188rem;
      border: 0;
      background-color: transparent;
      margin: 0;
      color: #fff;
      svg {
        height: 0.688rem;
        width: auto;
        margin-left: 5px;
      }
    }
  }
  input {
    color: #fff;
    background: transparent;
    border: 0;
    height: 1.25rem;
    border-bottom: 1px solid #fff;
    text-align: center;
    ::placeholder {
      color: #fff;
      font-size: 13px;
      font-weight: 600;
    }
  }
  .icons-container {
    img {
      height: 2.063rem;
      width: auto;
    }
    display: flex;
    justify-content: end;
    gap: 1rem;
    margin-bottom: 3rem;
  }
  /* MEDIA */
  @media ${size.md} {
    .form-control {
      width: auto;
    }
    .bulletin-signup {
      flex-direction: row;
      align-items: end;
    }
    .icons-container {
      height: initial;
      width: initial;
      margin-bottom: initial;
    }
  }

  @media ${size.lg} {
    .icons-container {
      visibility: visible !important;
    }
  }
`
const BottomContainer = styled.div`
  .item {
    padding-bottom: 0rem;
    font-family: "Helvetica Neue LT Std Cn", sans-serif;
  }

  font-family: "Helvetica Neue LT Std", sans-serif;
  font-weight: 300;
  font-size: 9px;
  display: flex;
  justify-content: space-between;
  align-items: start;
  border-top: 1px solid #fff;
  padding-top: 30px;
  flex-direction: column;
  /* MEDIA */
  @media ${size.md} {
    flex-direction: row;
  }
`
const CopyrightSection = styled.div`
  color: #fff;
  font-family: "Helvetica Neue LT Std Ex";
  letter-spacing: 0.1rem;

  .copyright-container {
    text-align: left;
  }

  .copyright-text {
    display: inline-block;
    vertical-align: bottom;
    padding: 12px 0px;
  }

  .logo-img {
    vertical-align: text-bottom;
  }
`

const Footer = () => {
  const [email, setEmail] = useState("")

  const handleSubmit = event => {
    event.preventDefault()
    let link = `https://bulletins.alvarezandmarsal.com/?email=${encodeURIComponent(
      email
    )}`

    window.location.replace(link)
  }

  return (
    <FooterContainer className="bg-light fluid">
      <ScrollToTop />
      <ContentContainer>
        <SectionsContainer>
          <div>
            <ColContainer className="logo-container">
              <Col className="logo">
                <LogoFooter />
              </Col>
              <Col className="icons-mobile">
                <div>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/alvarez-&-marsal/"
                    rel="noreferrer"
                    className="iconMedia"
                  >
                    <FaLinkedinIn className="icon" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/alvarezandmarsal"
                    rel="noreferrer"
                    className="iconMedia"
                  >
                    <FaFacebookF className="icon" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    href="https://twitter.com/alvarezmarsal"
                    rel="noreferrer"
                    className="iconMedia"
                  >
                    <FaXTwitter className="icon" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/user/AlvarezMarsal"
                    rel="noreferrer"
                    className="iconMedia"
                  >
                    <FaYoutube className="icon"/>
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.instagram.com/alvarezandmarsal_life/"
                    className="iconMedia"
                  >
                    <AiFillInstagram className="icon"/>
                  </a>
                </div>
              </Col>
            </ColContainer>
          </div>
          <div className="global-links">
          <ColContainer className="contact-privacy-box">
            <Col className="global">
                <p className="item">
                  <a href="/location">Global Locations</a>
                </p>
                <p className="item">
                  <a href="https://www.alvarezandmarsal.com/expertise" target="_blank">Expertise</a>
                </p>
                <p className="item">
                  <a href="https://www.alvarezandmarsal.com/industries" target="_blank">Industries</a>
                </p>
                <p className="item">
                  <a href="/insights">Insights</a>
                </p>
                <p className="item">
                  <a href="/leadership">Our People</a>
                </p>
              </Col>
              </ColContainer>
              <ColContainer className="contact-privacy-box">
              <Col className="careers">
                <p className="item">
                  <a href="https://www.alvarezandmarsal.com/careers">Careers</a>
                </p>
                <p className="item">
                  <a href="https://www.alvarezandmarsal.com/about-am">
                    About A&M
                  </a>
                </p>
              </Col>
              </ColContainer>
              <ColContainer className="contact-privacy-box">
                <Col className="global">
                <p className="item">
                  <a href="https://www.alvarezandmarsal.com/#block-connect-with-us">
                    Contact Us
                  </a>
                </p>
                <p className="item">
                  <a href="https://www.alvarezandmarsal.com/alumni">Alumni</a>
                </p>
                <p className="item">
                  <a href="https://www.a-mcapital.com/">A&M Capital</a>
                </p>
                <p className="item">
                  <a href="https://www.amcapitalre.com/">
                    A&M Capital Real Estate
                  </a>
                </p>
              </Col>
          </ColContainer>
          </div>
          <ColContainer className="contact-privacy-box">
            <Col className="global privacy">
              <p className="item privacy-item">
                <a href="https://www.alvarezandmarsal.com/privacy-notice">
                  Privacy Notice
                </a>
              </p>
              <p className="item privacy-item">
                <a href="https://www.alvarezandmarsal.com/DPF-notice-alvarez-marsal-disputes-and-investigations-llc">
                  EU-US/Swiss-US Data Protection Framework Notice
                </a>
              </p>
              <p className="item privacy-item">
                <a href="https://www.alvarezandmarsal.com/privacy-notice-california">
                  California Privacy Notice
                </a>
              </p>
              <p className="item privacy-item">
                <a href="https://www.alvarezandmarsal.com/cookie-policy">
                  Cookie Notice
                </a>
              </p>
              <p className="item privacy-item">
                <a href="https://www.alvarezandmarsal.com/terms-use">
                  Terms of Use
                </a>
              </p>
            </Col>
          </ColContainer>
          
          <ColContainer className="bulletin-container">
            <ColBox className="bulletin-box">
              <Col className="icons-container">
                <div>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/alvarez-&-marsal/"
                    rel="noreferrer"
                    className="iconMedia"
                  >
                    <FaLinkedinIn className="icon"/>
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/alvarezandmarsal"
                    rel="noreferrer"
                    className="iconMedia"
                  >
                    <FaFacebookF className="icon" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    href="https://twitter.com/alvarezmarsal"
                    rel="noreferrer"
                    className="iconMedia"
                  >
                    <FaXTwitter className="icon" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/user/AlvarezMarsal"
                    rel="noreferrer"
                    className="iconMedia"
                  >
                    <FaYoutube className="icon" />
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.instagram.com/alvarezandmarsal_life/"
                    className="iconMedia"
                  >
                    <AiFillInstagram className="icon" />
                  </a>
                </div>
              </Col>

              <Form onSubmit={handleSubmit} className="form-col">
                <Form.Group controlId="email" className="bulletin-signup">
                  <Form.Label>A&M Bulletin Sign-Up</Form.Label>
                  <Form.Control
                    placeholder="EMAIL"
                    type="email"
                    value={email}
                    onChange={ev => setEmail(ev.target.value)}
                    required={true}
                  />
                  <button type="submit" className="button-subscribe">
                    SUBSCRIBE
                    <span>
                      <ArrowRight />
                    </span>
                  </button>
                </Form.Group>
              </Form>
            </ColBox>
          </ColContainer>
        </SectionsContainer>
        <BottomContainer>
          <CopyrightSection>
            <div class="copyright-container">
              <div class="copyright-text">
                © Copyright {new Date().getFullYear()}. Alvarez Marsal Holdings,
                LLC. All Rights Reserved.
              </div>
              <br />
              <div class="copyright-text">ALVAREZ & MARSAL®,</div>
              <div class="copyright-text">
                <img
                  class="logo-img"
                  alt="A&amp;M Logo"
                  data-entity-type="file"
                  data-entity-uuid="e8360120-9a63-4435-9866-040966aa9495"
                  src="https://www.alvarezandmarsal.com/sites/default/files/inline-images/am_corporate_all_white_0.png"
                  width="20"
                  height="18"
                  loading="lazy"
                />
                ®,
              </div>
              <div class="copyright-text">
                <img
                  class="logo-img"
                  alt="A&amp;M Logo"
                  data-entity-type="file"
                  data-entity-uuid="9db22211-b10f-4817-9ea5-00ddf9e22721"
                  src="https://www.alvarezandmarsal.com/sites/default/files/inline-images/am-old-logo_white.png"
                  width="20"
                  height="18"
                  loading="lazy"
                />
                ®,
              </div>
              <div class="copyright-text">
                <img
                  alt=""
                  class="logo-img"
                  height="35"
                  src="data:image/png;base64,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"
                  width="61"
                />
                ® and A&M®
              </div>
              <div class="copyright-text">
                are trademarks of Alvarez & Marsal Holdings, LLC.
              </div>
              <br />
              <p class="copyright-text">
                Note: Alvarez & Marsal employs CPAs, but is not a licensed CPA
                firm.
              </p>
            </div>
          </CopyrightSection>
        </BottomContainer>
      </ContentContainer>
    </FooterContainer>
  )
}

export default Footer